<template>
  <div>
	<!-- <p v-if="isAuth">logado</p>
	<p v-else>não logado</p>
	<a href="#" v-if="isAuth"  @click="logout">Logout</a>
	-->
  </div>
</template>
<script>
	export default{
		computed:{
			isAuth(){
				return this.$store.getters['app/isAuth'];
			}
		},
		methods:{
			logout(){
				this.$store.dispatch('app/logout');
			}
		},
		beforeCreate(){
			this.$store.commit('app/setTitleScreen','Bem Vindo');
		}
	}
</script>